import DotNetObject = DotNet.DotNetObject;
import { MproDef } from '@crimsontide/core/client/interfaces';

export const MproDefService = (() => {
  let dotNetObj: DotNetObject;
  let cachedMproDefs: MproDef[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getMproDefs = async (useCache: boolean = true): Promise<MproDef[]> => {
    if (useCache && cachedMproDefs != null)
      return cachedMproDefs;

    if (dotNetObj) {
      cachedMproDefs = await dotNetObj.invokeMethodAsync<MproDef[]>('GetAsync');
      return cachedMproDefs;
    } else {
      throw 'Mpro Def DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getMproDefs,
  };
})();
